import React from 'react';

/**
 * Placeholder for a feature that exists but isn't open yet.
 *
 * Deliberately not an empty state: it says what the feature will do and why
 * it's held back, so the page reads as a roadmap item rather than something
 * broken. Mirrors the "Coming soon" bundle card on the download page.
 */
export default function ComingSoon({ icon: Icon, title, blurb, points = [], note }) {
  return (
    <div>
      <div className="page-head">
        <div className="page-title">
          <h2>
            {title}
            <span className="soon-tag">Coming soon</span>
          </h2>
          {blurb && <p>{blurb}</p>}
        </div>
      </div>

      <div className="pair-card soon-card">
        {Icon && (
          <div className="soon-icon"><Icon size={22} /></div>
        )}
        {points.length > 0 && (
          <ul className="soon-list">
            {points.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        )}
        {note && <p className="soon-note-block">{note}</p>}
        <p className="soon-note-block">
          Want it sooner, or want to be a first user? Email{' '}
          <a href="mailto:info@puttv.io">info@puttv.io</a>.
        </p>
      </div>
    </div>
  );
}
